<template>
  <div class="top-bar flex justify-end">
    <div class="qb-bar flex flex-wrap items-center justify-end text-white">
      <!-- Volver -->
      <v-button @click="$router.go(-1)" color="grey" size="small" icon="arrow-left" class="mr-8 mb-1">
        {{ $t('back') }}
      </v-button>

      <!-- Acciones del proyecto. El de la página actual (hiddenOption) NO se oculta:
           se muestra en gris y deshabilitado, dando sensación de "seleccionado". -->
      <v-button-icon-round
        v-for="a in actions"
        :key="a.option"
        :icon="a.icon"
        :tooltip="a.tooltip"
        :tooltip-position="a.pos"
        :color="a.option === hiddenOption ? 'grey' : 'blue'"
        :disabled="a.option === hiddenOption"
        @click="push({ name: a.route })"
        class="mr-1 mb-1" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'project-admin-quick-buttons',

  computed: {
    ...mapGetters({
      navData: "app/navData",
      project: "app/project",
    })
  ,
    storehouseRouteName() {
      // tenemos 2 tipos de Almacenes: Classic storehouse (0) y Warehouse v2.0 (1)
      const warehouseType = Number(this.project && this.project.warehouse_type ? this.project.warehouse_type : 0);
      return warehouseType === 1 ? 'project.admin.warehouse' : 'project.admin.storehouse';
    },

    // Acciones de la barra. `option` debe coincidir con el `hiddenOption` que pasa
    // cada página (el actual se muestra en gris/seleccionado en vez de ocultarse).
    actions() {
      return [
        { option: 'edit',                      route: 'project.edit',                         icon: 'pencil-alt',           tooltip: 'edit_project',            pos: 'bottom' },
        { option: 'validations',               route: 'project.admin.validations',            icon: 'project-diagram',      tooltip: 'validations',             pos: 'bottom' },
        { option: 'departments',               route: 'project.departments',                  icon: 'code-branch',          tooltip: 'go_to_departments',       pos: 'bottom' },
        { option: 'locations',                 route: 'project.admin.locations',              icon: 'map-marker-alt',       tooltip: 'locations',               pos: 'bottom' },
        { option: 'import_export_activities',  route: 'project.import-export-activities',     icon: 'file-excel',           tooltip: 'import_export_activities', pos: 'left' },
        { option: 'report-config',             route: 'project.admin.report-config',          icon: 'file-alt',             tooltip: 'report_config',           pos: 'bottom' },
        { option: 'manage-statuses',           route: 'project.manage-statuses',              icon: 'traffic-light',        tooltip: 'manage_statuses',         pos: 'bottom' },
        { option: 'assignments',               route: 'project.admin.assignments',            icon: 'tasks',                tooltip: 'measurements',            pos: 'bottom' },
        { option: 'extrafields',               route: 'project.admin.extrafields',            icon: 'object-ungroup',       tooltip: 'extrafields',             pos: 'bottom' },
        { option: 'issues',                    route: 'project.admin.issues',                 icon: 'exclamation-triangle', tooltip: 'issues',                  pos: 'bottom' },
        { option: 'drawings',                  route: 'project.admin.drawings',               icon: 'file-pdf',             tooltip: 'documents_drawings',      pos: 'bottom' },
        { option: 'pictograms',                route: 'project.admin.pictograms',             icon: 'solar-panel',          tooltip: 'pictograms',              pos: 'bottom' },
        { option: 'partners',                  route: 'project.admin.partners',               icon: 'handshake',            tooltip: 'partners',                pos: 'bottom' },
        { option: 'documents_folders',         route: 'project.admin.document-folders',       icon: 'folder-plus',          tooltip: 'documents_folders',       pos: 'bottom' },
        { option: 'storehouse',                route: this.storehouseRouteName,               icon: 'store-alt',            tooltip: 'storehouse',              pos: 'bottom' },
        { option: 'cost_budget',               route: 'project.admin.cost-management',        icon: 'file-invoice-dollar',  tooltip: 'cost_budget',             pos: 'left' },
        { option: 'permitting',                route: 'project.admin.permittings',            icon: 'file-signature',       tooltip: 'permitting',              pos: 'left' },
        { option: 'technical-specification',   route: 'project.admin.technical-specification', icon: 'cogs',                tooltip: 'technical_specification', pos: 'left' },
        { option: 'work-orders',               route: 'project.admin.work-orders',            icon: 'person-digging',       tooltip: 'purchase_order',          pos: 'left' },
      ];
    },
  },

  components: {},

  props: { hiddenOption: { type: String, required: true } },

  data: () => ({}),

  watch: {},

  mounted() {
  },

  methods: {
    push(args) {
      this.$store.dispatch('app/updateNavData', {
        project_id: this.navData.project_id,
        project_name: this.navData.project_name
      });

      args.project_id = this.navData.project_id;
      args.project_name = this.navData.project_name;
      this.$router.push(args);
    },

  },

};
</script>
